import { useState } from "react";

import { AiOutlineHome } from "react-icons/ai";
import {
  FaChalkboardTeacher,
  FaChevronDown,
  FaChevronUp,
  FaRegBuilding,
} from "react-icons/fa";
import { GrDocumentNotes } from "react-icons/gr";
import {
  IoMedal,
  IoOptions,
  IoPersonOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import { LiaCitySolid } from "react-icons/lia";
import { LuArrowLeftToLine } from "react-icons/lu";
import { MdApproval, MdAssignment, MdPendingActions } from "react-icons/md";
import { PiStudentFill } from "react-icons/pi";
import { RiEnglishInput, RiGovernmentFill, RiUpload2Line } from "react-icons/ri";
import { RxDotFilled } from "react-icons/rx";
import { SiHomeassistantcommunitystore } from "react-icons/si";
import { SlLogout } from "react-icons/sl";
import { Link, NavLink } from "react-router-dom";
import { IoMdNotifications } from "react-icons/io";
import "./DashboardMenu.css";

const DashboardMenu = () => {
  const [examNotesAllLinksToggle, setExamNotesAllLinksToggle] = useState(false);
  const [homeTutorAllLinksToggle, setHomeTutorAllLinksToggle] = useState(false);
  const [homeWorkAssitAllLinksToggle, setHomeWorkAssitAllLinksToggle] =
    useState(false);
  const [showSAndC, setShowSAndC] = useState(false);
  const [showSliders, setShowSliders] = useState(false);

  function handleExamNotesToggleFun() {
    setExamNotesAllLinksToggle(!examNotesAllLinksToggle);
    setHomeTutorAllLinksToggle(false);
    setHomeWorkAssitAllLinksToggle(false);
  }
  function handleHomeTutorToggleFun() {
    setHomeTutorAllLinksToggle(!homeTutorAllLinksToggle);
    setExamNotesAllLinksToggle(false);
    setHomeWorkAssitAllLinksToggle(false);
  }
  function handlehomeWorkAssitToggleFun() {
    setHomeWorkAssitAllLinksToggle(!homeWorkAssitAllLinksToggle);
    setExamNotesAllLinksToggle(false);
    setHomeTutorAllLinksToggle(false);
  }

  let [studentLinksVisible, setStudentLinksVisible] = useState(false);
  let [studentLinkUpIcon, setStudentLinkUpIcon] = useState(false);
  let [studentbgColorChange, setStudentbgColorChange] = useState(false);

  let [courseLinksVisible, setCourseLinksVisible] = useState(false);
  let [courseLinkUpIcon, setCourseLinkUpIcon] = useState(false);
  let [coursebgColorChange, setCoursebgColorChange] = useState(false);

  let [departmentLinksVisible, setDepartmentLinksVisible] = useState(false);
  let [departmentLinkUpIcon, setDepartmentLinkUpIcon] = useState(false);
  let [departmentbgColorChange, setDepartmentbgColorChange] = useState(false);

  let [feeManagementLinksVisible, setFeeManagementLinksVisible] =
    useState(false);
  let [feeManagementLinkUpIcon, setFeeManagementLinkUpIcon] = useState(false);
  let [feeManagementbgColorChange, setFeeManagementbgColorChange] =
    useState(false);

  const [showTeacherDropdown, setShowTeacherDropdown] = useState(false);
  const [showLiveClassDropdown, setShowLiveClassDropdown] = useState(false);
  const [showOthersDropdown, setShowOthersDropdown] = useState(false);
  const [showCouponDropdown, setShowCouponDropdown] = useState(false);
  const [showPricingDropdown, setShowPricingDropdown] = useState(false);
  const [activeLink, setActiveLink] = useState("");

  let handleStudLinkDrop = () => {
    setStudentLinksVisible(!studentLinksVisible);
    setStudentLinkUpIcon(!studentLinkUpIcon);
    setStudentbgColorChange(!studentbgColorChange);

    setCourseLinkUpIcon(false);
    setDepartmentLinkUpIcon(false);
    setFeeManagementLinkUpIcon(false);

    setCoursebgColorChange(false);
    setDepartmentbgColorChange(false);
    setFeeManagementbgColorChange(false);

    setCourseLinksVisible(false);
    setDepartmentLinksVisible(false);
    setFeeManagementLinksVisible(false);
    setStudentbgColorChange(!studentbgColorChange);
  };
  let handleCourseLinkDrop = () => {
    setCourseLinksVisible(!courseLinksVisible);
    setCourseLinkUpIcon(!courseLinkUpIcon);
    setCoursebgColorChange(!coursebgColorChange);

    setStudentLinkUpIcon(false);
    setDepartmentLinkUpIcon(false);
    setFeeManagementLinkUpIcon(false);

    setStudentbgColorChange(false);
    setDepartmentbgColorChange(false);
    setFeeManagementbgColorChange(false);

    setStudentLinksVisible(false);
    setDepartmentLinksVisible(false);
    setFeeManagementLinksVisible(false);
  };
  let handleDepLinkDrop = () => {
    setDepartmentLinksVisible(!departmentLinksVisible);
    setDepartmentLinkUpIcon(!departmentLinkUpIcon);
    setDepartmentbgColorChange(!departmentbgColorChange);

    setStudentLinkUpIcon(false);
    setCourseLinkUpIcon(false);
    setFeeManagementLinkUpIcon(false);

    setStudentbgColorChange(false);
    setCoursebgColorChange(false);
    setFeeManagementbgColorChange(false);

    setStudentLinksVisible(false);
    setCourseLinksVisible(false);
    setFeeManagementLinksVisible(false);
  };
  let handleFeeManagLinkDrop = () => {
    setFeeManagementLinksVisible(!feeManagementLinksVisible);
    setFeeManagementLinkUpIcon(!feeManagementLinkUpIcon);
    setFeeManagementbgColorChange(!feeManagementbgColorChange);

    setStudentLinkUpIcon(false);
    setCourseLinkUpIcon(false);
    setDepartmentLinkUpIcon(false);

    setStudentbgColorChange(false);
    setCoursebgColorChange(false);
    setDepartmentbgColorChange(false);

    setStudentLinksVisible(false);
    setCourseLinksVisible(false);
    setDepartmentLinksVisible(false);
  };

  const role = localStorage.getItem("role");
  const services = localStorage.getItem("services");
  const isSubAdmin = role === "subAdmin";

  return (
    <aside className="dashboard-aside custom-scroll">
      {/* Brand */}
      <div className="aside-brand">
        <div className="aside-brand-mark">P4U</div>
        <div className="aside-brand-text">
          <h1>
            Path4U <span className="brand-badge">ADMIN</span>
          </h1>
          <span className="aside-brand-sub">Control Panel</span>
        </div>
      </div>

      {/* Account chip */}
      <div className="aside-account">
        <img src="https://i.pravatar.cc/100?img=12" alt="admin avatar" />
        <div className="aside-account-info">
          <span className="aside-account-name">Admin</span>
          <span className="aside-account-role">
            {isSubAdmin ? "Sub Admin" : "Super Admin"}
          </span>
        </div>
      </div>

      <ul id="aside-menu">
        {!isSubAdmin ? (
          <>
            <li className="aside-section-label">Overview</li>

            <li className="menu-link-item">
              <div>
                <NavLink to={"/"}>
                  <AiOutlineHome className="menu-icon-mr" />
                  Dashboard
                </NavLink>
              </div>
            </li>

            <li className="aside-section-label">Academics</li>

            <div className="stud-dropdown-main-button">
              <li
                onClick={handleStudLinkDrop}
                id={`${studentbgColorChange ? "menu-link-bgColor" : null}`}
                className="menu-link-item"
              >
                <div>
                  <NavLink>
                    <IoPersonOutline className="menu-icon-mr" />
                    School
                    {!studentLinkUpIcon ? (
                      <FaChevronDown className="main-up-down-icon" />
                    ) : (
                      <FaChevronUp className="main-up-down-icon" />
                    )}
                  </NavLink>
                </div>
              </li>

              {studentLinksVisible ? (
                <div className="student-dropdown">
                  <ul className="menu-link-dropdown-ul">
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "Boards" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("Boards")}
                    >
                      <Link to={"/school-add-board"}>Boards</Link>
                    </li>
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "Class" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("Class")}
                    >
                      <Link to={"/school-add-class"}>Class</Link>
                    </li>
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "Subject" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("Subject")}
                    >
                      <Link to={"/school-add-subject"}>Subject</Link>
                    </li>
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "NiosClass" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("NiosClass")}
                    >
                      <Link to={"/nios-add-class"}>Nios Class</Link>
                    </li>
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "NiosSubject" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("NiosSubject")}
                    >
                      <Link to={"/nios-add-subject"}>Nios Subject</Link>
                    </li>
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "Category" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("Category")}
                    >
                      <Link to={"/add-category"}>Category</Link>
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>

            <div className="course-dropdown-main-btn">
              <li
                onClick={handleCourseLinkDrop}
                id={`${coursebgColorChange ? "menu-link-bgColor" : null}`}
                className="menu-link-item course-menu-link-item"
              >
                <div>
                  <Link>
                    <FaRegBuilding className="menu-icon-mr" />
                    University
                    {!courseLinkUpIcon ? (
                      <FaChevronDown className="main-up-down-icon" />
                    ) : (
                      <FaChevronUp className="main-up-down-icon" />
                    )}
                  </Link>
                </div>
              </li>
              {courseLinksVisible ? (
                <div className="course-dropdown">
                  <ul className="menu-link-dropdown-ul">
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "University" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("University")}
                    >
                      <Link to={"/university-add"}>University</Link>
                    </li>
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "CourseUniversity" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("CourseUniversity")}
                    >
                      <Link to={"/college-add-course"}>Course</Link>
                    </li>
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "SemesterUniversity" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("SemesterUniversity")}
                    >
                      <Link to={"/college-semester"}>Semester</Link>
                    </li>
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "SubjectUniversity" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("SubjectUniversity")}
                    >
                      <Link to={"/college-subject"}>Subject</Link>
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>

            <div className="department-dropdown-main-btn">
              <li
                onClick={handleDepLinkDrop}
                id={`${departmentbgColorChange ? "menu-link-bgColor" : null}`}
                className="menu-link-item department-menu-link-item"
              >
                <div>
                  <Link>
                    <LuArrowLeftToLine className="menu-icon-mr" />
                    Competitive Exam
                    {!departmentLinkUpIcon ? (
                      <FaChevronDown className="main-up-down-icon" />
                    ) : (
                      <FaChevronUp className="main-up-down-icon" />
                    )}
                  </Link>
                </div>
              </li>

              {departmentLinksVisible ? (
                <div className="department-dropdown">
                  <ul className="menu-link-dropdown-ul">
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "ExamCategory" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("ExamCategory")}
                    >
                      <Link to={"/ce-exam-add-category"}>Exam Category</Link>
                    </li>
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "CompetitiveExamSubject"
                          ? "active-link"
                          : ""
                      }`}
                      onClick={() => setActiveLink("CompetitiveExamSubject")}
                    >
                      <Link to={"/ce-add-subject"}>Subject</Link>
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>

            <li
              className="menu-link-item"
              onClick={() => setShowOthersDropdown(!showOthersDropdown)}
            >
              <div>
                <Link>
                  <LiaCitySolid className="menu-icon-mr" />
                  Others
                  {showOthersDropdown ? (
                    <FaChevronUp className="main-up-down-icon" />
                  ) : (
                    <FaChevronDown className="main-up-down-icon" />
                  )}
                </Link>
              </div>
            </li>

            {showOthersDropdown && (
              <ul className="menu-link-dropdown-ul">
                <li className="menu-link-dropdown-li">
                  <Link to="/all-category">Category</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/all-category-topic">Category Topics</Link>
                </li>
              </ul>
            )}

            <li className="aside-section-label">Student Services</li>

            <div className="feeManagement-dropdown-main-btn">
              <li onClick={handleFeeManagLinkDrop} className="menu-link-item">
                <div>
                  <NavLink>
                    <PiStudentFill className="menu-icon-mr" />
                    Student
                    {!feeManagementLinksVisible ? (
                      <FaChevronDown className="main-up-down-icon" />
                    ) : (
                      <FaChevronUp className="main-up-down-icon" />
                    )}
                  </NavLink>
                </div>
              </li>
              {feeManagementLinksVisible ? (
                <div className="feeManagement-dropdown">
                  <ul className="menu-link-dropdown-ul">
                    <li
                      className={`menu-link-dropdown-li ${
                        activeLink === "StudentProfile" ? "active-link" : ""
                      }`}
                      onClick={() => setActiveLink("StudentProfile")}
                    >
                      <MdPendingActions className="menu-icon-mr" />
                      <Link to={"/student-profile"}>Student Profile</Link>
                    </li>

                    <li
                      className="menu-link-dropdown-li"
                      onClick={handleExamNotesToggleFun}
                    >
                      <GrDocumentNotes className="menu-icon-mr" />
                      <Link>Exam Notes</Link>
                    </li>
                    {examNotesAllLinksToggle ? (
                      <ul className="menu-exam-notes-ul">
                        <li className="menu-exam-notes-li">
                          <RxDotFilled />
                          <Link to={"/upload-notes/upload-all-notes"}>
                            Upload Notes
                          </Link>
                        </li>
                      </ul>
                    ) : null}

                    <li className="menu-link-dropdown-li">
                      <IoOptions className="menu-icon-mr" />
                      <Link to={"/management"}>Choose Career</Link>
                    </li>

                    <li
                      className="menu-link-dropdown-li"
                      onClick={handleHomeTutorToggleFun}
                    >
                      <FaChalkboardTeacher className="menu-icon-mr" />
                      <Link>Home Tutor</Link>
                    </li>
                    {homeTutorAllLinksToggle ? (
                      <ul className="exam-notes-home-tutor-ul">
                        <li className="exam-notes-home-tutor-li">
                          <RxDotFilled />
                          <Link to={"home-tutor/tuition-management-system"}>
                            Tuition Management
                          </Link>
                        </li>
                      </ul>
                    ) : null}

                    <li
                      className="menu-link-dropdown-li"
                      onClick={handlehomeWorkAssitToggleFun}
                    >
                      <SiHomeassistantcommunitystore className="menu-icon-mr" />
                      <Link>Homework Assistance</Link>
                    </li>

                    {homeWorkAssitAllLinksToggle ? (
                      <ul className="exam-notes-home-work-assistance-ul">
                        <li className="exam-notes-home-work-assistance-li">
                          <RxDotFilled />
                          <Link to={"home-work-assistance/student-hw-list"}>
                            Home Work
                          </Link>
                        </li>
                        <li className="exam-notes-home-work-assistance-li">
                          <RxDotFilled />
                          <Link to={"/home-work-assistance/solution-hw-list"}>
                            Home Work Solution
                          </Link>
                        </li>
                      </ul>
                    ) : null}
                    <li className="menu-link-dropdown-li">
                      <MdApproval />
                      <Link to={"/student-subjective-exam"}>
                        Subjective Exam
                      </Link>
                    </li>

                    <li className="menu-link-dropdown-li">
                      <MdAssignment />
                      <Link to={"/student-assignment"}>Assignment</Link>
                    </li>
                    <li className="menu-link-dropdown-li">
                      <IoMedal />
                      <Link to={"/student-scholarship"}>
                        Student Scholarship
                      </Link>
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>

            <li
              className="menu-link-item"
              onClick={() => setShowLiveClassDropdown(!showLiveClassDropdown)}
            >
              <div>
                <Link>
                  <LiaCitySolid className="menu-icon-mr" />
                  Live Classes
                  {showLiveClassDropdown ? (
                    <FaChevronUp className="main-up-down-icon" />
                  ) : (
                    <FaChevronDown className="main-up-down-icon" />
                  )}
                </Link>
              </div>
            </li>

            {showLiveClassDropdown && (
              <ul className="menu-link-dropdown-ul">
                <li className="menu-link-dropdown-li">
                  <Link to="/live-class-add">Add Live Class</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/live-class-list">All Live Class</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/live-class-purchase">Purchase List</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/live-class-session">Live Class Session</Link>
                </li>
              </ul>
            )}

            <li className="menu-link-item">
              <div onClick={() => setShowTeacherDropdown(!showTeacherDropdown)}>
                <Link>
                  <FaChalkboardTeacher className="menu-icon-mr" />
                  Teacher
                  {showTeacherDropdown ? (
                    <FaChevronUp className="main-up-down-icon" />
                  ) : (
                    <FaChevronDown className="main-up-down-icon" />
                  )}
                </Link>
              </div>
            </li>

            {showTeacherDropdown && (
              <ul className="menu-link-dropdown-ul">
                <li className="menu-link-dropdown-li">
                  <Link to="/teacher-profile">Teacher Profile</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/subjective-teacher-assigning">
                    Teacher Assign Subjective
                  </Link>
                </li>
              </ul>
            )}

            <li className="aside-section-label">Site Content</li>

            <li
              className="menu-link-item"
              onClick={() => setShowSAndC(!showSAndC)}
            >
              <div>
                <Link>
                  <LiaCitySolid className="menu-icon-mr" />
                  State & City
                  {showSAndC ? (
                    <FaChevronUp className="main-up-down-icon" />
                  ) : (
                    <FaChevronDown className="main-up-down-icon" />
                  )}
                </Link>
              </div>
            </li>

            {showSAndC && (
              <ul className="menu-link-dropdown-ul">
                <li className="menu-link-dropdown-li">
                  <Link to="/create-state">State</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/create-city">City</Link>
                </li>
              </ul>
            )}

            <li
              className="menu-link-item"
              onClick={() => setShowSliders(!showSliders)}
            >
              <div>
                <Link>
                  <LiaCitySolid className="menu-icon-mr" />
                  Sliders
                  {showSliders ? (
                    <FaChevronUp className="main-up-down-icon" />
                  ) : (
                    <FaChevronDown className="main-up-down-icon" />
                  )}
                </Link>
              </div>
            </li>

            {showSliders && (
              <ul className="menu-link-dropdown-ul">
                <li className="menu-link-dropdown-li">
                  <Link to="/add-sliders">Add Sliders</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/all-sliders">All Sliders</Link>
                </li>
              </ul>
            )}

            <li
              className="menu-link-item"
              onClick={() => setShowCouponDropdown(!showCouponDropdown)}
            >
              <div>
                <Link>
                  <LiaCitySolid className="menu-icon-mr" />
                  Offer and Coupons
                  {showCouponDropdown ? (
                    <FaChevronUp className="main-up-down-icon" />
                  ) : (
                    <FaChevronDown className="main-up-down-icon" />
                  )}
                </Link>
              </div>
            </li>

            {showCouponDropdown && (
              <ul className="menu-link-dropdown-ul">
                <li className="menu-link-dropdown-li">
                  <Link to="/add-coupons">Add Coupons</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/all-coupons">All Coupons</Link>
                </li>
              </ul>
            )}

            <li
              className="menu-link-item"
              onClick={() => setShowPricingDropdown(!showPricingDropdown)}
            >
              <div>
                <Link>
                  <LiaCitySolid className="menu-icon-mr" />
                  Pricing
                  {showPricingDropdown ? (
                    <FaChevronUp className="main-up-down-icon" />
                  ) : (
                    <FaChevronDown className="main-up-down-icon" />
                  )}
                </Link>
              </div>
            </li>

            {showPricingDropdown && (
              <ul className="menu-link-dropdown-ul">
                <li className="menu-link-dropdown-li">
                  <Link to="/add-appointment-pricing">
                    Appointment Pricing
                  </Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/assignment-pricing">Assignment Pricing</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/add-wallet-pricing">Wallet Pricing</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/add-home-work-pricing">Home Work Pricing</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/exam-notes-pricing">Exam Notes Pricing</Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/subjective-exam-pricing">
                    Subjective Exam Pricing
                  </Link>
                </li>
                <li className="menu-link-dropdown-li">
                  <Link to="/add-home-tutor-pricing">Home Tutor Pricing</Link>
                </li>
              </ul>
            )}

            <li className="aside-section-label">General</li>

            <li className="menu-link-item">
              <div>
                <Link to={"/government-approved-council"}>
                  <RiGovernmentFill className="menu-icon-mr" />
                  Govt. Approved Council
                </Link>
              </div>
            </li>

            <li className="menu-link-item">
              <div>
                <Link to={"/push-notification"}>
                  <IoMdNotifications className="menu-icon-mr" />
                  Notifications
                </Link>
              </div>
            </li>

            <li className="menu-link-item">
              <div>
                <Link to={"/all-company-details"}>
                  <RiGovernmentFill className="menu-icon-mr" />
                  Company Details
                </Link>
              </div>
            </li>

            <li className="menu-link-item">
              <div>
                <Link to={"/all-appointment"}>
                  <RiGovernmentFill className="menu-icon-mr" />
                  All Appointments
                </Link>
              </div>
            </li>

            <li className="menu-link-item">
              <div>
                <Link to={"/job"}>
                  <RiGovernmentFill className="menu-icon-mr" />
                  Job
                </Link>
              </div>
            </li>

            <li className="menu-link-item">
              <div>
                <Link to={"/current_affairs"}>
                  <RiGovernmentFill className="menu-icon-mr" />
                  Current Affairs
                </Link>
              </div>
            </li>

            <li className="menu-link-item">
              <div>
                <Link to={"/updates"}>
                  <RiGovernmentFill className="menu-icon-mr" />
                  Update
                </Link>
              </div>
            </li>



            <li className="menu-link-item">
              <div>
                <Link to={"/english-course"}>
                  <RiEnglishInput className="menu-icon-mr" />
                  English Courses
                </Link>
              </div>
            </li>

            <li className="menu-link-item">
              <div>
                <Link to={"/home-update"}>
                  <RiUpload2Line className="menu-icon-mr" />
                  HomeScreen Updates
                </Link>
              </div>
            </li>

            <li className="aside-section-label">Account</li>

            <li className="menu-link-item">
              <div>
                <Link to={"/settings"}>
                  <IoSettingsOutline className="menu-icon-mr" />
                  Sub Admin
                </Link>
              </div>
            </li>

            <li className="menu-link-item">
              <div>
                <Link to={"/changepass"}>
                  <IoSettingsOutline className="menu-icon-mr" />
                  Change Password
                </Link>
              </div>
            </li>

            <li className="menu-link-item logout-item">
              <div>
                <Link to={"/logout"}>
                  <SlLogout className="menu-icon-mr" />
                  Logout
                </Link>
              </div>
            </li>
          </>
        ) : (
          <>
            <li className="aside-section-label">Student Services</li>

            <div className="feeManagement-dropdown-main-btn">
              <li onClick={handleFeeManagLinkDrop} className="menu-link-item">
                <div>
                  <NavLink>
                    <PiStudentFill className="menu-icon-mr" />
                    Student
                    {!feeManagementLinksVisible ? (
                      <FaChevronDown className="main-up-down-icon" />
                    ) : (
                      <FaChevronUp className="main-up-down-icon" />
                    )}
                  </NavLink>
                </div>
              </li>
              {feeManagementLinksVisible ? (
                <div className="feeManagement-dropdown">
                  <ul className="menu-link-dropdown-ul">
                    {services.includes("student_profile") && (
                      <li
                        className={`menu-link-dropdown-li ${
                          activeLink === "StudentProfile" ? "active-link" : ""
                        }`}
                        onClick={() => setActiveLink("StudentProfile")}
                      >
                        <MdPendingActions className="menu-icon-mr" />
                        <Link to={"/student-profile"}>Student Profile</Link>
                      </li>
                    )}

                    {services.includes("exam_notes") && (
                      <li
                        className="menu-link-dropdown-li"
                        onClick={handleExamNotesToggleFun}
                      >
                        <GrDocumentNotes className="menu-icon-mr" />
                        <Link>Exam Notes</Link>
                      </li>
                    )}
                    {examNotesAllLinksToggle ? (
                      <ul className="menu-exam-notes-ul">
                        <li className="menu-exam-notes-li">
                          <RxDotFilled />
                          <Link to={"/upload-notes/upload-all-notes"}>
                            Upload Notes
                          </Link>
                        </li>
                      </ul>
                    ) : null}

                    {services.includes("choose_career") && (
                      <li className="menu-link-dropdown-li">
                        <IoOptions className="menu-icon-mr" />
                        <Link to={"/management"}>Choose Career</Link>
                      </li>
                    )}

                    {services.includes("home_tutor") && (
                      <li
                        className="menu-link-dropdown-li"
                        onClick={handleHomeTutorToggleFun}
                      >
                        <FaChalkboardTeacher className="menu-icon-mr" />
                        <Link>Home Tutor</Link>
                      </li>
                    )}
                    {homeTutorAllLinksToggle ? (
                      <ul className="exam-notes-home-tutor-ul">
                        <li className="exam-notes-home-tutor-li">
                          <RxDotFilled />
                          <Link to={"home-tutor/tuition-management-system"}>
                            Tuition Management
                          </Link>
                        </li>
                      </ul>
                    ) : null}

                    {services.includes("homework_assistance") && (
                      <li
                        className="menu-link-dropdown-li"
                        onClick={handlehomeWorkAssitToggleFun}
                      >
                        <SiHomeassistantcommunitystore className="menu-icon-mr" />
                        <Link>Homework Assistance</Link>
                      </li>
                    )}

                    {homeWorkAssitAllLinksToggle ? (
                      <ul className="exam-notes-home-work-assistance-ul">
                        <li className="exam-notes-home-work-assistance-li">
                          <RxDotFilled />
                          <Link to={"home-work-assistance/student-hw-list"}>
                            Home Work
                          </Link>
                        </li>
                        <li className="exam-notes-home-work-assistance-li">
                          <RxDotFilled />
                          <Link to={"/home-work-assistance/solution-hw-list"}>
                            Home Work Solution
                          </Link>
                        </li>
                      </ul>
                    ) : null}

                    {services.includes("subjective_exam") && (
                      <li className="menu-link-dropdown-li">
                        <MdApproval />
                        <Link to={"/student-subjective-exam"}>
                          Subjective Exam
                        </Link>
                      </li>
                    )}

                    {services.includes("assignment") && (
                      <li className="menu-link-dropdown-li">
                        <MdAssignment />
                        <Link to={"/student-assignment"}>Assignment</Link>
                      </li>
                    )}

                    {services.includes("jobs") && (
                      <li className="menu-link-dropdown-li">
                        <RiGovernmentFill className="menu-icon-mr" />
                        <Link to={"/job"}>Job</Link>
                      </li>
                    )}

                    {services.includes("current_affairs") && (
                      <li className="menu-link-dropdown-li">
                        <RiGovernmentFill className="menu-icon-mr" />
                        <Link to={"/current_affairs"}>Current Affairs</Link>
                      </li>
                    )}
                  </ul>
                </div>
              ) : null}
            </div>

            <li className="aside-section-label">Account</li>

            <li className="menu-link-item logout-item">
              <div>
                <Link to={"/logout"}>
                  <SlLogout className="menu-icon-mr" />
                  Logout
                </Link>
              </div>
            </li>
          </>
        )}
      </ul>
    </aside>
  );
};

export default DashboardMenu;